
(function() {
  var result = { translations: { "de": { "i18n": { "duration": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min.", "days": "{{ days }} Tage", "shortForm": { "seconds": "{{ seconds }} Sek.", "minutes": "{{ minutes }} Min.", "hours": "{{ hours }} Std.", "days": "{{ days }} Tage", "hoursAndMinutes": "{{ hours }} Std. {{ minutes }} Min." } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, Durchwahl {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "de": "static-7.1172"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1172",
    "ar-eg": "static-7.1172",
    "bg": "static-7.1172",
    "bn": "static-7.1172",
    "ca-es": "static-7.1172",
    "cs": "static-7.1172",
    "da": "static-7.1172",
    "de": "static-7.1172",
    "el": "static-7.1172",
    "en-gb": "static-7.1172",
    "en": "static-7.1172",
    "es-mx": "static-7.1172",
    "es": "static-7.1172",
    "et": "static-7.1172",
    "fi": "static-7.1172",
    "fr-ca": "static-7.1172",
    "fr": "static-7.1172",
    "he-il": "static-7.1172",
    "hi": "static-7.1172",
    "hr": "static-7.1172",
    "hu": "static-7.1172",
    "id": "static-7.1172",
    "it": "static-7.1172",
    "ja": "static-7.1172",
    "ko": "static-7.1172",
    "lt": "static-7.1172",
    "ms": "static-7.1172",
    "nl": "static-7.1172",
    "no": "static-7.1172",
    "pl": "static-7.1172",
    "pt-br": "static-7.1172",
    "pt-pt": "static-7.1172",
    "ro": "static-7.1172",
    "ru": "static-7.1172",
    "sk": "static-7.1172",
    "sl": "static-7.1172",
    "sv": "static-7.1172",
    "th": "static-7.1172",
    "tl": "static-7.1172",
    "tr": "static-7.1172",
    "uk": "static-7.1172",
    "vi": "static-7.1172",
    "x-pseudo": "static-7.1172",
    "zh-cn": "static-7.1172",
    "zh-hk": "static-7.1172",
    "zh-tw": "static-7.1172"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:de', {version: 'static-7.1172'}); }
})();


